<template>
  <div class="mb-4" v-if="nrePage.nreData">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="caption-label">
        Basic Information
        <b-badge style="margin-left: 13.5px;" v-if="$attrs.isETOSELECT" variant="primary">ETO Sector SKU</b-badge>
      </div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div>
              <gtc-ftie :ftieId="basic_info_review.ftie_id" />
            </div>
            <!--
                      <div>{{ basic_info_review.ftie_id }}</div>

        -->
          </div>
          <div class="header-col">
            <div>ETO NRE</div>
            <div>{{ basic_info_review.nre_id }}</div>
          </div>
          <div class="header-col">
            <div>Salesforce ES</div>
            <div>{{ basic_info_review.sales_force_es_no }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Salesforce Opportunity</div>
            <gtc-opportunity :opportunityId="basic_info_review.sales_force_opty_id"
                             :opportunityName="basic_info_review.sales_force_opty" />
          </div>
          <div class="header-col">
            <div>Account Name</div>
            <div>{{ basic_info_review.account }}</div>
          </div>
          <div class="header-col">
            <div>Account Currency</div>
            <div>{{ basic_info_review.sales_force_opty_currency }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Product</div>
            <div>{{ basic_info_review.nre_model }}</div>
          </div>
          <div class="header-col">
            <div>Customization SKU ID</div>
            <div>{{ basic_info_review.sku_id }}</div>
          </div>
          <div class="header-col" v-if="detectCustomizationSkuDifferFromBasicInfoSku()">
            <div class="text-danger">SKU Change Log:</div>
            <div class="text-danger">{{ basic_info_review.sku_id_before_pm_made_substitution }} (Before SKU Substitution)</div>
          </div>
        </div>
      </div>
      <div class="caption-label">Reference(Standard) SKU Price Information</div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="row">
            <div class="col-auto">
              <div class="header-col">
                <div>Standard SKU ID</div>
                <div>{{ _.get(skuItem, 'sku_id', '') }}</div>
              </div>
              <div class="small text-danger" v-if="_.isNil(skuItem)">This SKU ID can't be displayed. Please substitute it.</div>
              <!--
                <div class="small text-danger" v-if="_.get(skuItem,'price_info.eol',false)">This SKU ID has been EOL!</div>
                -->


            </div>
            <!-- Hide substitute btn in ES PM Leader Stage-->
            <!--
           <div class="col d-print-none" v-if="!$attrs.readOnly && _.get(skuItem,'price_info.cost_empty',true)">
             <button type="button" class="btn btn-primary" @click="$emit('substitute')">Substitute</button>
           </div>

      -->

          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>HQ Cost</div>
            <div>{{ $attrs.currencySign}} {{ _.get(skuItem, 'price_info.hq_cost', '') | comma }}</div>
          </div>
          <div class="header-col">
            <div>GRO Cost</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.gro_cost', '') | comma }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Distributor Price</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.distributor_price', '') | comma }}</div>
          </div>
          <div class="header-col">
            <div>Reseller Price</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.reseller_price', '') | comma }}</div>
          </div>
          <div class="header-col">
            <div>MSRP</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.msrp', '') | comma }}</div>
          </div>
        </div>

        <div class="col-12"
             v-if="skuItem !== null && (_.get(skuItem,'price_info.eol',false) || (_.get(skuItem,'remark','') !== '' && _.get(skuItem,'remark','') !== null))">
          <div class="row">
            <div class="col-auto">
              <b-alert show variant="danger" class="d-flex align-items-start gap-2 py-2 px-3">
                <span style="font-size:1.1em; line-height:1.5; flex-shrink:0;">&#9888;</span>
                <div>
                  <div v-if="_.get(skuItem,'price_info.eol',false)"><strong>This SKU ID has been EOL!</strong></div>
                  <div v-if="_.get(skuItem,'remark','') !== '' && _.get(skuItem,'remark','') !== null">
                    <strong>Remark:</strong> {{_.get(skuItem,'remark','')}}
                  </div>
                </div>
              </b-alert>
            </div>
          </div>
        </div>

      </div>


      <!--#region NEW!! ES PM NRE Remark Fields -->
      <div v-if="basic_info_review.espm_nre_remark" class="stage-body-gtc-sales-comments-and-conclusions">
        <div class="caption-label">ES PM Remarks for the NRE</div>
        <div style="margin-bottom: 15px;">
          <gtc-froala :read-only="true" v-model="basic_info_review.espm_nre_remark" />
        </div>
        <br />
      </div>
      <!--#endregion ES PM NRE Remark Fields-->
      <!--#endregion Header-->
    </div>
    <div style="margin-bottom: 6rem;">
      <div class="border-bottom pb-4 mb-4">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <!--#region NRE Estimation-->
            <div class="stage-body-nre-estimation">
              <div class="caption-label">NRE Estimation</div>
              <div>
                <div class="header-col">
                  <div>Module</div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="$attrs.readOnly" class="" v-model="nre_estimation_from_espm.module" />
                  </div>
                </div>
                <div class="header-col">
                  <div>PoC Required</div>
                  <div>
                    <b-form-radio-group :disabled="$attrs.readOnly"
                                        v-model="nre_estimation_from_espm.poc_required"
                                        @change="$emit('pocRequiredChange')">
                      <b-form-radio value="Y">Yes</b-form-radio>
                      <b-form-radio value="N">No</b-form-radio>
                    </b-form-radio-group>
                  </div>
                </div>
                <!--#region Table-->
                <div class="mt-3">
                  <table class="table nre-estimation-table table-sm">
                    <colgroup>
                      <col style="width: 1px;" />
                      <col style="width: 1px;" />
                      <col />
                      <col style="width: 6rem;" />
                      <col style="width: 6rem;" />
                    </colgroup>
                    <thead class="text-dark thead-light">
                      <tr>
                        <th>Category</th>
                        <th colspan="2">Item</th>
                        <th>{{ $attrs.pocWordingES }}</th>
                        <th>{{ $attrs.mpWordingES }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!--#region Labor Cost-->
                      <tr>
                        <td rowspan="2">Labor Cost</td>
                        <td colspan="2">Development</td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.labor_cost.development.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.labor_cost.development.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td colspan="2">Verification</td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.labor_cost.verification.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.labor_cost.verification.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Test Sample-->
                      <tr>
                        <td rowspan="2">Test Sample</td>
                        <td colspan="2">
                          <div class="row align-items-center">
                            <div class="col">A. EQT Test Sample</div>
                            <div class="col-auto ml-auto">
                              <gtc-number :read-only="$attrs.readOnly" :decimalLen="0" class="min-w-6" v-model="nre_estimation_from_espm.test_sample.eqt_sample" />
                            </div>
                            <div class="col-auto pl-0" style="width: 3rem">sets</div>
                          </div>
                        </td>
                        <td rowspan="2"><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.test_sample.poc_cost" /></td>
                        <td rowspan="2" class="text-right">{{ test_sample_mp_cost | comma }}</td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="row align-items-center">
                            <div class="col">B. Sharing rate</div>
                            <div class="col-auto ml-auto">
                              <gtc-number :read-only="$attrs.readOnly" class="min-w-6" v-model="nre_estimation_from_espm.test_sample.sharing_rate" />
                            </div>
                            <div class="col-auto pl-0" style="width: 3rem">%</div>
                          </div>
                        </td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Job Cost-->
                      <tr>
                        <td rowspan="5">Job Cost</td>
                        <td colspan="2">Tooling Fee</td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.job_cost.tooling_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.job_cost.tooling_fee.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td colspan="2">PCB Fabrication Fee</td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.job_cost.pcb_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.job_cost.pcb_fee.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td colspan="2">Test Jig / Fixture</td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.job_cost.test_jig.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.job_cost.test_jig.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td colspan="2">Outsource Fee</td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.job_cost.outsource_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.job_cost.outsource_fee.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Others</td>
                        <td><gtc-textarea :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.job_cost.job_cost_others.remark"></gtc-textarea></td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.job_cost.job_cost_others.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.job_cost.job_cost_others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Regulation-->
                      <tr>
                        <td rowspan="4">Regulation</td>
                        <td>EMC</td>
                        <td><gtc-text-box :read-only="$attrs.readOnly" class="" v-model="nre_estimation_from_espm.regulation.emc.remark" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.regulation.emc.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.regulation.emc.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Safety</td>
                        <td><gtc-text-box :read-only="$attrs.readOnly" class="" v-model="nre_estimation_from_espm.regulation.safety.remark" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.regulation.safety.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.regulation.safety.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Environmental</td>
                        <td><gtc-text-box :read-only="$attrs.readOnly" class="" v-model="nre_estimation_from_espm.regulation.environment.remark" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.regulation.environment.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.regulation.environment.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Others</td>
                        <td><gtc-textarea :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.regulation.regulation_others.remark"></gtc-textarea></td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.regulation.regulation_others.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.regulation.regulation_others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Others-->
                      <tr>
                        <td>Others</td>
                        <td colspan="2"><gtc-textarea :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.others.remark"></gtc-textarea></td>
                        <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="nre_estimation_from_espm.others.poc_cost" /></td>
                        <td><gtc-number :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>Total NRE</td>
                        <td></td>
                        <td></td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost | comma }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <!--#endregion-->
              </div>
            </div>
            <!--#endregion-->
          </div>
          <div class="col">
            <!--#region Customization Proposal-->
            <div class="stage-body-customization-proposal">
              <div class="caption-label">Customization Proposal</div>
              <div>
                <gtc-froala :read-only="$attrs.readOnly" v-model="nre_estimation_from_espm.customization_proposal" />
              </div>
            </div>
            <!--#endregion-->
            <!--#region Project Proposal File-->
            <div class="stage-body-project-proposal-file mt-3">
              <div class="caption-label d-flex">
                <div>Project Proposal File</div>
                <div class="ml-3 mb-1 d-print-none" v-if="!$attrs.readOnly">
                  <label class="btn btn-primary btn-sm">
                    <span>Upload</span>
                    <input type="file" class="d-none" v-on:change="$emit('uploadProjectProposalFile',$event)" />
                  </label>
                </div>
              </div>
              <div>
                <b-table small thead-class="thead-light text-dark"
                         :items="proposal_files" :fields="nrePage.projectProposalFileSetting">
                  <template #cell(file_name)="data">
                    <a herf="#" class="file" @click="$emit('getFile',data.item)">{{data.item.file_name}}</a>
                  </template>
                  <template #cell(update_time)="data">
                    {{ data.item.update_time | dateTimeFormat }}
                  </template>
                  <template #cell(delete)="data">
                    <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                            @click="$emit('deleteProjectProposalFile', data.index)"></button>
                  </template>
                </b-table>
              </div>
            </div>
            <!--#endregion-->
            <!--#region Reference Files-->
            <div class="stage-body-reference-files mt-3">
              <div class="caption-label d-flex">
                <div>Reference Files</div>
                <div class="ml-3 mb-1 d-print-none" v-if="!$attrs.readOnly">
                  <label class="btn btn-primary btn-sm">
                    <span>Upload</span>
                    <input type="file" class="d-none" v-on:change="$emit('uploadReferenceFile',$event)" />
                  </label>
                </div>
              </div>
              <div>
                <b-table small thead-class="thead-light text-dark" style="table-layout: fixed;"
                         :items="reference_files" :fields="nrePage.referenceFilesSetting">
                  <template #cell(file_name)="data">
                    <a herf="#" class="file" @click="$emit('getFile',data.item)">{{data.item.file_name}}</a>
                  </template>
                  <template #cell(update_time)="data">
                    {{ data.item.update_time | dateTimeFormat }}
                  </template>
                  <template #cell(delete)="data">
                    <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                            @click="$emit('deleteReferenceFile',data.index)"></button>
                  </template>
                </b-table>
              </div>
            </div>
            <!--#endregion-->
          </div>
        </div>
      </div>
      <!--#region Cost Per Unit Estimation-->
      <div class="stage-body-cost-per-unit-estimation border-bottom pb-4 mb-4">
        <div class="caption-label">Cost Per Unit Estimation</div>
        <div>
          <table class="table table-sm cost-per-unit-estimation-table">
            <colgroup>
              <col style="width:1px;" />
              <col style="width:6rem;" />
              <col style="width:6rem;" />
              <col />
            </colgroup>
            <thead class="text-dark thead-light">
              <tr>
                <th class="text-nowrap">Category</th>
                <th class="text-nowrap">{{ $attrs.pocWordingES }}</th>
                <th class="text-nowrap">{{ $attrs.mpWordingES }}</th>
                <th class="text-nowrap">Remark</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Demand Quantity</td>
                <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="unit_estimation_from_espm.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="$attrs.readOnly" v-model="unit_estimation_from_espm.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-text-box :read-only="$attrs.readOnly" class="" v-model="unit_estimation_from_espm.demand_quantity.remark" /></td>
              </tr>
              <tr>
                <td>
                  <div>(A) NRE Amortization / Per unit (for MP)</div>
                  <div class="p-tab d-flex align-items-center">
                    <b-form-checkbox v-model="unit_estimation_from_espm.nre_amortization.nre_amortization_check"
                                     :disabled="$attrs.readOnly"
                                     @change="unit_estimation_from_espm.nre_amortization.nre_amortization_quantity = 0"
                                     value="Y" unchecked-value="N">NRE Amortization Quantity:</b-form-checkbox>

                    <gtc-number :read-only="$attrs.readOnly || unit_estimation_from_espm.nre_amortization.nre_amortization_check !== 'Y'"
                                :decimalLen="0" class="ml-2 min-w-6"
                                v-model="unit_estimation_from_espm.nre_amortization.nre_amortization_quantity" />

                  </div>
                </td>
                <td class="text-center">–</td>
                <td><div class="text-right px-2">{{ nre_amortization_cost_result | comma }}</div></td>
                <td class="px-2">–</td>
              </tr>
              <tr>
                <td>
                  <div>(B) Cost of Base unit (Reference SKU)</div>
                  <div class="p-tab d-flex align-items-center">
                    <div>Reference PN:</div>
                    <div class="ml-2">{{ unit_estimation_from_espm.cost_base_unit.remark }}</div>
                    <button v-if="!$attrs.readOnly" type="button" class="btn btn-sm btn-primary ml-2 min-w-4" @click="$emit('changeRefPn')">Edit</button>
                  </div>
                  <div class="p-tab d-flex align-items-center">Deduct Cost:</div>
                </td>
                <td>
                  <gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="unit_estimation_from_espm.cost_base_unit.poc_cost" /> <br />
                  <gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="unit_estimation_from_espm.deduct_cost.poc_cost" />
                </td>
                <td>
                  <gtc-number :read-only="$attrs.readOnly" v-model="unit_estimation_from_espm.cost_base_unit.mp_cost" /><br />
                  <gtc-number :read-only="$attrs.readOnly" v-model="unit_estimation_from_espm.deduct_cost.mp_cost" />
                </td>

                <td>
                  <div class="d-flex">
                    <span style="color: gray; font-style: italic; margin-top: 22.6px;">* Describe the deduction if have any</span>
                  </div>
                  <div class="d-flex" style="margin-top: 2px;" v-if="$attrs.readOnly && unit_estimation_from_espm.deduct_cost.remark === null">
                    <gtc-text-box :read-only="$attrs.readOnly" class="" v-model="nullValModel" />
                  </div>
                  <div class="d-flex" style="margin-top: 2px;" v-else>
                    <gtc-text-box :read-only="$attrs.readOnly" class="" v-model="unit_estimation_from_espm.deduct_cost.remark" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>(C) Additional Material Cost / Per unit</td>
                <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="unit_estimation_from_espm.additional_material_cost.poc_cost" /></td>
                <td><gtc-number :read-only="$attrs.readOnly" v-model="unit_estimation_from_espm.additional_material_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="$attrs.readOnly" class="" v-model="unit_estimation_from_espm.additional_material_cost.remark" /></td>
              </tr>
              <tr>
                <td>(D) Additional MVA Cost / Per unit</td>
                <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="unit_estimation_from_espm.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number :read-only="$attrs.readOnly" v-model="unit_estimation_from_espm.additional_mva_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="$attrs.readOnly" v-model="unit_estimation_from_espm.additional_mva_cost.remark" /></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total cost/Per unit (=A+B+C+D)</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_poc_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_mp_cost | comma }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region Lead-time Estimation and Notices-->
      <div class="stage-body-lead-time-estimation-and-notices border-bottom pb-4 mb-4">
        <div class="caption-label">Lead-time Estimation and Notices</div>
        <div>
          <gtc-froala :read-only="$attrs.readOnly" v-model="lead_time_notice.note_text" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region ETO Sector SKU INFO : P/N -->
      <div v-if="$attrs.isETOSELECT" style="margin-bottom: 6rem;">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <div class="stage-body-nre-estimation">
              <div class="caption-label">ETO Sector SKU P/N and Limitations</div>
              <div>
                <div class="header-col">
                  <div>MPS P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="$attrs.readOnly" class="" v-model="basic_info_review.eto_sector_sku.eto_select_mps_pn" />
                  </div>
                </div>
                <div class="header-col">
                  <div>SHIP P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="$attrs.readOnly" class="" v-model="basic_info_review.eto_sector_sku.eto_select_ship_pn" />
                  </div>
                </div>
                <div class="border-bottom"></div>
                <div class="header-col">
                  <div>
                    Conditions & Limitations
                  </div>
                  <div>
                    <b-form-checkbox v-model="hasRemark"
                                     name="check-button"
                                     :disabled="$attrs.readOnly"
                                     @change="remarkSwitch()"
                                     switch>
                      This ETO Sector SKU <span v-if="hasRemark"><b>has</b></span>
                      <span v-else><b>has no</b></span>
                      additional conditions and limitations
                      <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                              v-b-tooltip.hover.right
                              title="This remark will pass to eQuote, appending in the quotation line.">
                      </button>
                    </b-form-checkbox>

                  </div>
                </div>
                <div v-if="$attrs.readOnly" class="flex-fill">

                  <b-form-textarea v-if="hasRemark"
                                   id="textarea-plaintext"
                                   class="w-100"
                                   style="background: #eee;"
                                   plaintext :value=" _.get(nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', '')">
                  </b-form-textarea>
                </div>
                <div v-else class="flex-fill">
                  <textarea v-if="hasRemark"
                            class="w-100"
                            v-model="nrePage.nreData.page_object.basic_info_review.eto_sector_sku.remark">
                    </textarea>

                  <div v-if="hasRemark" :class="classObject(_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.remark', ''), 300)">
                    <span>You've input: {{ _.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.remark', '') | getInputLength }}/300</span>
                  </div>

                </div>

                <!--
                <div class="border-bottom"></div>

                  <div class="header-col">
                    <div>Document Link</div>
                    <div class="flex-fill">
                      <div v-if="$attrs.readOnly && hasDocumentLink">
                        <b-link :href="_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', '')">{{_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', '')}}</b-link>
                      </div>
                      <div v-else-if="$attrs.readOnly !== true">
                        <gtc-text-box :read-only="$attrs.readOnly" class="" v-model="basic_info_review.eto_sector_sku.document" />
                      </div>
                      <div v-else>
                        <gtc-text-box :read-only="$attrs.readOnly"
                                      class=""
                                      v-model="nullValModel" />
                      </div>
                    </div>
                  </div>

  -->

              </div>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion ETO Sector SKU INFO : P/N -->
      <!-- #region Quote Items for ETO Sector SKU -->
      <div v-if="$attrs.isETOSELECT" class="stage-body-customize-quote-items">
        <div class="caption-label d-flex">
          <div>ETO Sector SKU Quote Items (to eQuote)</div>
          <div class="ml-3 mb-1 d-print-none" v-if="!$attrs.readOnly && $attrs.aliveQuoteTypes.length > 0">
            <button type="button" class="btn btn-primary btn-sm min-w-4" @click="$emit('quoteItemModal')">Add</button>
          </div>
        </div>
        <div>
          <b-table small thead-class="thead-light text-dark"
                   :items="$attrs.quoteItemsMapping" :fields="nrePage.customizeQuoteItemsSetting"
                   tbody-tr-class="position-relative">

            <template #cell(sku_id)="data">

              <div v-if="detectCustomizationSkuChangedBySubstitution(data.item.sku_id)">
                <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                        v-b-tooltip.hover.right
                        :title=" `Detect ID is different from the substituted SKU, which is ${_.get(nrePage.nreData.page_object, 'customization_sku_id', '')}. Please delete and add a new quote item!`">
                </button>
                <span class="text-danger">{{ data.item.sku_id }}</span>
              </div>
              <div v-else>
                {{ data.item.sku_id }}
              </div>
            </template>

            <template #cell(qty)="data">
              {{ data.item.qty | comma(0) }}
            </template>

            <template #cell(amortize_qty)="data">
              <div v-if="['MP', 'MP NRE', 'MP Addition Cost'].includes(data.item.quote_type)" v-for="item in data.item.details">
                <div v-if="data.item.details.length > 1 || data.item.create_function !== 'ES PM'"
                     class="position-absolute px-3 text-left text-white"
                     :class="{'bg-primary': item.create_function === createFunction,
                              'bg-gray-560': item.create_function !== createFunction}"
                     style="width: 13rem;">
                  {{ item.create_function }}
                </div>
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.amortize_qty | comma(0) }}</div>
              </div>
            </template>
            <template #cell(hq_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.hq_cost | comma }}</div>
              </div>
            </template>
            <template #cell(action)="data">
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit" @click="$emit('quoteItemModal', data.item)"></button>
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete" @click="$emit('removeQuoteItem',data.item)"></button>
            </template>
          </b-table>
        </div>
      </div>
      <!-- #end region-->
      <!--#region Customize Quote Items-->
      <div v-else class="stage-body-customize-quote-items">
        <div class="caption-label d-flex">
          <div>Customize Quote Items</div>
          <div class="ml-3 mb-1 d-print-none" v-if="!$attrs.readOnly && $attrs.aliveQuoteTypes.length > 0">
            <button type="button" class="btn btn-primary btn-sm min-w-4" @click="$emit('quoteItemModal')">Add</button>
          </div>
        </div>
        <div>
          <b-table small thead-class="thead-light text-dark"
                   :items="$attrs.quoteItemsMapping" :fields="nrePage.customizeQuoteItemsSetting"
                   tbody-tr-class="position-relative">

            <template #cell(sku_id)="data">

              <div v-if="detectCustomizationSkuChangedBySubstitution(data.item.sku_id)">
                <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                        v-b-tooltip.hover.right
                        :title=" `Detect ID is different from the substituted SKU, which is ${_.get(nrePage.nreData.page_object, 'customization_sku_id', '')}. Please delete and add a new quote item!`">
                </button>
                <span class="text-danger">{{ data.item.sku_id }}</span>
              </div>
              <div v-else>
                {{ data.item.sku_id }}
              </div>
            </template>

            <template #cell(qty)="data">
              {{ data.item.qty | comma(0) }}
            </template>
            <template #cell(amortize_qty)="data">
              <div v-if="['MP', 'MP NRE', 'MP Addition Cost'].includes(data.item.quote_type)" v-for="item in data.item.details">
                <div v-if="data.item.details.length > 1 || data.item.create_function !== 'ES PM'"
                     class="position-absolute px-3 text-left text-white"
                     :class="{'bg-primary': item.create_function === createFunction,
                              'bg-gray-560': item.create_function !== createFunction}"
                     style="width: 13rem;">
                  {{ item.create_function }}
                </div>
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.amortize_qty | comma(0) }}</div>
              </div>
            </template>
            <template #cell(hq_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.hq_cost | comma }}</div>
              </div>
            </template>
            <template #cell(action)="data">
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit" @click="$emit('quoteItemModal', data.item)"></button>
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete" @click="$emit('removeQuoteItem',data.item)"></button>
            </template>
          </b-table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region NEW!! Reject Reason Section-->
      <div v-if="$attrs.showReasonSection" class="stage-body-gtc-sales-comments-and-conclusions">
        <br />
        <div class="caption-label d-flex">
          <div>
            <span class="badge badge-danger" style="font-size: 16px;margin-bottom: 5px;">ES PM Leader Reject Reason</span>
          </div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.reject_reason" />
        </div>
      </div>
      <!--#endregion-->

    </div>
    <div class="fixed-bottom d-print-none" v-if="!$attrs.readOnly">
      <div class="row py-3 bg-gray-150 px-4 border-top border-gray-550">
        <template v-if="!$attrs.readOnly && emptyGulidStagesMsg!==''">
          <div class="col-auto ml-auto"><img style=" display: block;margin-left: auto;margin-right: auto;" src='../../static/image/stage_icon/icon_Canceled.svg' alt="cancel"></div>
          <div style='width:60rem;font-size:0.9rem;color:red'>
            {{emptyGulidStagesMsg}}
          </div>
        </template>
        <template v-else-if="!$attrs.readOnly">
          <div class="col-auto ml-auto p-0"></div>
        </template>
        <div class="col-auto">
          <button type="button" class="btn btn-success min-w-6" @click="$emit('save')">Save</button>
        </div>
        <div class="col-auto border-left p-0 border-gray-550" style="width:1px"></div>

        <div v-if="autoApproveCondtion()" class="col-auto">
          <button type="button" class="btn btn-danger" @click="$emit('reject')">Reject</button>
          <button type="button" class="btn btn-primary" v-if="!$attrs.readOnly && !nrePage.isSubmitted" @click="$emit('autoApprove')">Submit (Auto Approve)</button>
          <!--<button v-if="autoApproveCondtion()" type="button" class="btn btn-outline-primary" @click="$emit('autoApprove')">Auto Approve</button>
    -->
        </div>
        <div v-else class="col-auto">
          <button type="button" class="btn btn-danger" @click="$emit('reject')">Reject</button>
          <button type="button" class="btn btn-primary" v-if="!$attrs.readOnly && !nrePage.isSubmitted" @click="validate() && $emit('submit')">Submit to HQ Sales</button>
          <!--<button v-if="autoApproveCondtion()" type="button" class="btn btn-outline-primary" @click="$emit('autoApprove')">Auto Approve</button>
    -->
        </div>

      </div>
    </div>

    <!--#endregion-->
  </div>
</template>
<script>
  export default {
    data() {
      return {
        nullValModel: 'N/A',
        hasRemark: false,
        hasDocumentLink: false,
      };
    },
    created() {
      let self = this;
      if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) !== null && _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) !== '') {
        self.hasRemark = true;
      } else {
        self.hasRemark = false
      }

      if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) !== null && _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) !== '') {
        self.hasDocumentLink = true;
      } else {
        self.hasDocumentLink = false;
      }

      if (self.emptyGulidStagesMsg!== ''){
        self.$message.warning(self.emptyGulidStagesMsg, 'No Member Warning');
      }
    },
    computed: {
      emptyGulidStagesMsg() {
        let self = this;
        let message = '';
        let messageCont = '';
        if (self.nrePage.nreData.empty_gulid_stages !== undefined && self.nrePage.nreData.empty_gulid_stages.length !== 0) {
          message = `\nThere is no member data in stages:\n${self.nrePage.nreData.empty_gulid_stages.join(', ')}.\n\nPlease add members in FTIE admin function ASAP. `;
          if (_.indexOf(self.nrePage.nreData.empty_gulid_stages, 'SA Head Review') > -1) {
            messageCont = `\n* One of required stages is missing member - SA Head Review.`;
            console.log("Missing member in SA Head Review");
          }
          if (_.indexOf(self.nrePage.nreData.empty_gulid_stages, 'HQ Sales Review') > -1) {
            messageCont = `\n* One of required stages is missing member - HQ Sales Review.`;
            console.log("Missing member in HQ Sales Review");
          }
        }
        else {
          // all stages member have been set up, but contain 'SKIP' or Null in required stage
          console.log("all stages member have been set up, but contain 'SKIP' or Null in required stage");
          let saHeadName = '';
          let hqSalesName = '';
          saHeadName = self.nrePage.nreData.page_object.basic_info_review.sign_flow_members.GRO_SA_LEADER;
          saHeadName = (_.split(saHeadName, '@')[0]).toLowerCase();

          hqSalesName = self.nrePage.nreData.page_object.basic_info_review.sign_flow_members.HQ_SALES;
          hqSalesName = (_.split(hqSalesName, '@')[0]).toLowerCase();


          console.log(`saHeadName: ${saHeadName}`);
          console.log(`hqSalesName: ${hqSalesName}`);

          if ('skip' === saHeadName) {
            message = `\nOne of the required stage (SA Head Review) has been set to SKIP.\nPlease contact system administrator or update member in FTIE admin function ASAP.`;
          }
          if ('skip' === hqSalesName) {
            message = `\nOne of the required stage (HQ Sales Review) has been set to SKIP.\nPlease contact system administrator or update member in FTIE admin function ASAP.`;
          }
        }
        message = message + messageCont;
        return message;
      },

      pocRequired() {
        return this.nre_estimation_from_espm.poc_required === 'Y';
      },

      //#region -- Alias --

      stageNumber() {
        return this.$attrs.stageNumber;
      },
      createFunction() {
        return this.$attrs.createFunction;
      },
      skuItem() {
        return this.$attrs.skuItem;
      },
      nrePage: {
        get() {
          return this.$attrs.data;
        },
        set(value) {
          this.$attrs.data = value;
        }
      },
      basic_info_review: {
        get() {
          return this.nrePage.nreData.page_object.basic_info_review;
        },
        set(value) {
          this.nrePage.nreData.page_object.basic_info_review = value;
        }
      },
      nre_estimation_from_espm: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_from_espm;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_from_espm = value;
        }
      },
      // # TODO
      nre_estimation_pre_stage: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_pre_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_pre_stage = value;
        }
      },

      proposal_files: {
        get() {
          return this.nrePage.nreData.page_object.proposal_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.proposal_files = value;
        }
      },
      reference_files: {
        get() {
          return this.nrePage.nreData.page_object.reference_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.reference_files = value;
        }
      },
      lead_time_notice: {
        get() {
          return this.nrePage.nreData.page_object.lead_time_notice;
        },
        set(value) {
          this.nrePage.nreData.page_object.lead_time_notice = value;
        }
      },
      quote_items: {
        get() {
          return this.nrePage.nreData.page_object.quote_items;
        },
        set(value) {
          this.nrePage.nreData.page_object.quote_items = value;
        }
      },
      unit_estimation_from_espm: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_from_espm;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_from_espm = value;
        }
      },
      // # TODO
      unit_estimation_pre_stage: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_pre_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_pre_stage = value;
        }
      },


      //#endregion
      //#region -- Price --

      test_sample_mp_cost() {
        let self = this;

        let mp_cost_base_unit = self.unit_estimation_from_espm.cost_base_unit.mp_cost + self.unit_estimation_from_espm.deduct_cost.mp_cost * -1;
        let mp_cost_add_material = self.unit_estimation_from_espm.additional_material_cost.mp_cost;
        let mp_cost_add_mva = self.unit_estimation_from_espm.additional_mva_cost.mp_cost;
        let eqt_test_sample_qty = self.nre_estimation_from_espm.test_sample.eqt_sample;
        let sharing_rate_test_sample = self.nre_estimation_from_espm.test_sample.sharing_rate;
        let result = (mp_cost_base_unit + mp_cost_add_material + mp_cost_add_mva) * eqt_test_sample_qty * (sharing_rate_test_sample / 100);

        self.nre_estimation_from_espm.test_sample.mp_cost = _.round(result, 2);

        return self.nre_estimation_from_espm.test_sample.mp_cost;
      },
      nre_estimation_total_poc_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_from_espm.labor_cost.development.poc_cost,
          self.nre_estimation_from_espm.labor_cost.verification.poc_cost,
          self.nre_estimation_from_espm.test_sample.poc_cost,
          self.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.test_jig.poc_cost,
          self.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost,
          self.nre_estimation_from_espm.regulation.emc.poc_cost,
          self.nre_estimation_from_espm.regulation.safety.poc_cost,
          self.nre_estimation_from_espm.regulation.environment.poc_cost,
          self.nre_estimation_from_espm.regulation.regulation_others.poc_cost,
          self.nre_estimation_from_espm.others.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_from_espm.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_from_espm.labor_cost.development.mp_cost,
          self.nre_estimation_from_espm.labor_cost.verification.mp_cost,
          self.nre_estimation_from_espm.test_sample.mp_cost,
          self.nre_estimation_from_espm.job_cost.tooling_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.pcb_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.test_jig.mp_cost,
          self.nre_estimation_from_espm.job_cost.outsource_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.job_cost_others.mp_cost,
          self.nre_estimation_from_espm.regulation.emc.mp_cost,
          self.nre_estimation_from_espm.regulation.safety.mp_cost,
          self.nre_estimation_from_espm.regulation.environment.mp_cost,
          self.nre_estimation_from_espm.regulation.regulation_others.mp_cost,
          self.nre_estimation_from_espm.others.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_from_espm.total_cost.mp_cost = result;
        return result;
      },
      nre_amortization_cost_result() {
        let self = this;
        let mp_cost = self.nre_estimation_total_mp_cost;
        let amortization_quantity = self.unit_estimation_from_espm.nre_amortization.nre_amortization_quantity;

        let result = 0;
        if ('Y' === self.unit_estimation_from_espm.nre_amortization.nre_amortization_check && amortization_quantity !== 0) {
          result = _.round(mp_cost / amortization_quantity, 2);
        }

        self.unit_estimation_from_espm.nre_amortization.nre_amortization_cost = result;
        return result;
      },
      unit_estimation_total_poc_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_from_espm.cost_base_unit.poc_cost,
          self.unit_estimation_from_espm.additional_material_cost.poc_cost,
          self.unit_estimation_from_espm.additional_mva_cost.poc_cost,
          self.unit_estimation_from_espm.deduct_cost.poc_cost * -1
        ];
        let check_minus_result = _.round(_.sum([self.unit_estimation_from_espm.cost_base_unit.poc_cost, self.unit_estimation_from_espm.deduct_cost.poc_cost * -1]), 2);
        if (check_minus_result < 0) {
          self.unit_estimation_from_espm.deduct_cost.poc_cost = 0;
        }
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_from_espm.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_mp_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_from_espm.nre_amortization.nre_amortization_cost,
          self.unit_estimation_from_espm.cost_base_unit.mp_cost,
          self.unit_estimation_from_espm.additional_material_cost.mp_cost,
          self.unit_estimation_from_espm.additional_mva_cost.mp_cost,
          self.unit_estimation_from_espm.deduct_cost.mp_cost * -1
        ];
        let check_minus_result = _.round(_.sum([self.unit_estimation_from_espm.cost_base_unit.mp_cost, self.unit_estimation_from_espm.deduct_cost.mp_cost * -1]), 2);
        if (check_minus_result < 0) {
          self.unit_estimation_from_espm.deduct_cost.mp_cost = 0;
        }
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_from_espm.total_cost.mp_cost = result;
        return result;
      },

      //#endregion
    },
    methods: {
      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      remarkSwitch() {
        let self = this;
        if (self.hasRemark === false) {
          self.nrePage.nreData.page_object.basic_info_review.eto_sector_sku.remark = null;
        }
      },
      validate() {
        let self = this;

        let div = document.createElement('div');
        div.innerHTML = self.lead_time_notice.note_text;

        let items = _.filter($(div).find('span[style*="background-color: #fac51c;"]'), item => {
          return item.innerHTML === '__';
        });
        console.log(items.length);

        let fieldNames = _.map(items, item => { return $(item).attr('data-field'); });

        if (fieldNames.length > 0) {

          let message = `Please fill ${fieldNames.join(', ')} in Lead-time Estimation and Notices section.`;
          self.$message.warning(message, 'Lead-time Estimation and Notices');

          return false;
        }

        if (self.quote_items.length < 1) {
          self.$message.warning('Please add at least one quote item!', 'Customize Quote Items');

          return false;
        }

        if (self.emptyGulidStagesMsg !== '') {
          console.log('Please update the ETO sign flow member correctly or contact the system administrator.');
          self.$message.warning('\nSystem detect some potential errors in sign flow, which might effect the ETO process. \nPlease update the ETO sign flow correctly or contact the system administrator alice.cy.lee@getac.com.tw.', 'Potential Error Detected');

          return false;
        }

        return true;
      },
      detectCustomizationSkuDifferFromBasicInfoSku() {
        let self = this;
        if (_.get(self.basic_info_review, 'sku_id', null) !== null &&
          _.get(self.basic_info_review, 'sku_id', null) !== '' &&
          _.get(self.basic_info_review, 'sku_id', '') !== _.get(self.basic_info_review, 'sku_id_before_pm_made_substitution', null)) {
          return true;
        }
        else {
          return false;
        }
      },
      detectCustomizationSkuChangedBySubstitution(skuIdNeedToVarify) {
        let self = this;
        if (_.get(self.nrePage.nreData.page_object, 'customization_sku_id', null) !== null &&
          _.get(self.nrePage.nreData.page_object, 'customization_sku_id', null) !== '' &&
          _.get(self.nrePage.nreData.page_object, 'customization_sku_id', '') !== skuIdNeedToVarify) {
          return true;
        }
        else {
          return false;
        }
      },

      autoApproveCondtion() {
        // Return True or False
        /*
         * 1. GUSA
         * 2. Total NRE == 0
         * 3. Additional Material Cost / Per unit + Additional MVA Cost / Per unit == 0
         * 4. Ref sku selling price
         * */
        let self = this;
        let autoPassActiveRegion = []//['GUSA', 'GML', 'GUK', 'GDE', 'GFR', 'GMD-AFME', 'GMD-AU', 'GMD-CISCEE', 'GMD-E.ASIA', 'GMD-IN', 'GMD-IT', 'GMD-LATAM', 'GMD-S.ASIA', 'GMD-W.EU'];
        // nrePage.nreData.page_object.auto_pass_active_regions

        try {
          console.log("auto_pass_active_regions from B.E:");
          console.log(_.get(self.nrePage, 'nreData.page_object.auto_pass_active_regions', ''))
          autoPassActiveRegion = _.get(self.nrePage, 'nreData.page_object.auto_pass_active_regions', []);
        } catch (error) {
          console.log("failed to get AutoPass region list from B.E.");
          console.log(error);
        }

        if (autoPassActiveRegion.length === 0) {
          autoPassActiveRegion = ['GUSA', 'GML', 'GUK', 'GDE', 'GFR', 'GMD-AFME', 'GMD-AU', 'GMD-CISCEE', 'GMD-E.ASIA', 'GMD-IN', 'GMD-IT', 'GMD-LATAM', 'GMD-S.ASIA', 'GMD-W.EU'];
        }

        if (_.indexOf(autoPassActiveRegion, self.basic_info_review.region) == -1) {
          return false;
        }

        let additional_cost_per_unit_espm = self.unit_estimation_from_espm.additional_material_cost.mp_cost + self.unit_estimation_from_espm.additional_mva_cost.mp_cost;
        let additional_cost_per_unit_espm_poc = self.unit_estimation_from_espm.cost_base_unit.poc_cost + self.unit_estimation_from_espm.additional_material_cost.poc_cost + self.unit_estimation_from_espm.additional_mva_cost.poc_cost;
        //let additional_cost_per_unit_curr = self.unit_estimation_curr_stage.additional_material_cost.mp_cost + self.unit_estimation_curr_stage.additional_mva_cost.mp_cost;
        let total_nre_mp_espm = self.nre_estimation_total_mp_cost;
        let total_nre_poc_espm = self.nre_estimation_total_poc_cost;
        //let total_nre_mp_curr = self.nre_estimation_total_mp_cost_curr_stage;
        //let total_nre_poc_curr = self.nre_estimation_total_poc_cost_curr_stage;

        if (total_nre_mp_espm + total_nre_poc_espm > 0) {
          return false;
        }


        if (additional_cost_per_unit_espm > 0) {
          return false;
        }

        if (additional_cost_per_unit_espm_poc > 0) {
          return false;
        }

        if (self.skuItem === null || _.get(self.skuItem, 'price_info.cost_empty', '') === true || _.get(self.skuItem, 'price_info.reseller_price', '') === '') {
          return false;
        }

        return true
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EsPmLeaderReview.vue